import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { useViewport } from 'components/hooks'

import styles from './styles.module.scss'

const RateTableLoanTermValue = ({ minLoanTerm, maxLoanTerm }) => {
  const { xSmall } = useViewport()

  return (
    <div
      className={cx('pure-u-1 pure-u-md-1-4 pure-u-sm-1-3', {
        [styles.row]: xSmall,
      })}
    >
      <p className="bodySmall neutral500">Loan term</p>
      <p className="bodyLarge semiBold">
        {minLoanTerm} - {maxLoanTerm} years
      </p>
    </div>
  )
}

RateTableLoanTermValue.propTypes = {
  minLoanTerm: PropTypes.number.isRequired,
  maxLoanTerm: PropTypes.number.isRequired,
}

export default RateTableLoanTermValue
